import React from 'react';
import { FaPlay, FaArrowDown } from 'react-icons/fa';

const Hero = () => {
  return (
    <section className="bg-black text-white position-relative overflow-hidden" style={{ 
      minHeight: '100vh',
      marginTop: '56px'
    }}>
      {/* خلفية متحركة - دوائر بألوان تيك توك (أسود، سماوي، أحمر) */}
      <div className="position-absolute top-0 start-0 w-100 h-100">
        <div className="position-absolute rounded-circle" style={{
          width: '300px',
          height: '300px',
          top: '10%',
          left: '5%',
          background: 'rgba(0, 0, 0, 0.3)',
          animation: 'float 8s infinite ease-in-out'
        }}></div>
        <div className="position-absolute rounded-circle" style={{
          width: '500px',
          height: '500px',
          bottom: '-100px',
          right: '-100px',
          background: 'rgba(37, 244, 238, 0.15)', // سماوي
          animation: 'float 12s infinite ease-in-out reverse'
        }}></div>
        <div className="position-absolute rounded-circle" style={{
          width: '200px',
          height: '200px',
          top: '50%',
          right: '20%',
          background: 'rgba(255, 59, 89, 0.15)', // أحمر/وردي تيك توك
          animation: 'float 6s infinite ease-in-out'
        }}></div>
        <div className="position-absolute rounded-circle" style={{
          width: '400px',
          height: '400px',
          top: '60%',
          left: '10%',
          background: 'rgba(255, 255, 255, 0.05)',
          animation: 'float 10s infinite ease-in-out'
        }}></div>
      </div>

      <div className="container h-100 d-flex align-items-center position-relative" style={{ minHeight: 'calc(100vh - 56px)' }}>
        <div className="row w-100">
          <div className="col-lg-8 mx-auto text-center">
            <div className="mb-4" data-aos="fade-down">
              <span className="badge bg-white text-black px-3 py-2 rounded-pill fw-bold">
                🇦🇪 🇪🇬 وكالة إماراتية مصرية
              </span>
            </div>

            <h1 className="display-2 fw-bold mb-4" data-aos="fade-up" data-aos-delay="200">
              نصنع <span className="text-info">نجوم التيك توك</span>
            </h1>
            
            <p className="lead fs-3 mb-5 text-white-50" data-aos="fade-up" data-aos-delay="400">
              نحول المواهب إلى علامات تجارية مؤثرة في مصر والإمارات
            </p>

            <div className="row mb-5 g-4" data-aos="fade-up" data-aos-delay="600">
              <div className="col-4">
                <div className="fs-1 fw-bold text-info">+100</div>
                <div className="text-white-50">عميل</div>
              </div>
              <div className="col-4">
                <div className="fs-1 fw-bold text-danger">+200M</div>
                <div className="text-white-50">مشاهدة</div>
              </div>
              <div className="col-4">
                <div className="fs-1 fw-bold text-info">4+</div>
                <div className="text-white-50">سنوات خبرة</div>
              </div>
            </div>

            <div className="d-flex flex-column flex-sm-row justify-content-center gap-3" data-aos="zoom-in" data-aos-delay="800">
              <a href="#contact" className="btn btn-info btn-lg px-5 py-3 fw-bold text-black">
                <FaPlay className="me-2" /> ابدأ الآن
              </a>
              <a href="#services" className="btn btn-outline-danger btn-lg px-5 py-3">
                خدماتنا <FaArrowDown className="ms-2" />
              </a>
            </div>
          </div>
        </div>
      </div>

      <div className="position-absolute bottom-0 start-50 translate-middle-x mb-4">
        <a href="#about" className="text-white-50" style={{ animation: 'bounce 2s infinite' }}>
          <FaArrowDown size={24} />
        </a>
      </div>
    </section>
  );
};

export default Hero;